import http from '@/http/axios.instance';
import mapper from './refmodel.mapper';
import { RefmodelResponse } from './refmodelApi.types';

/**
 * Fetch ReferenceModel files
 * @param {string} project_uuid
 */
const getReferenceModels = async (project_uuid) => {
  const referenceModelsUrl = `/api/one/v1/projects/${project_uuid}/data/?state=1&skip_pagination=true&format=json&type=REFMODEL&extension__in=.DWG&extension__in=.LMD&extension__in=.TRM&extension__in=.MBS&extension__in=.DXF&extension__in=.xml&extension__in=.GEO&extension__in=.L3D&extension__in=.KOF&extension__in=.CFM&extension__in=.LIN&extension__in=.IRD&refmod_meta_data=1`;
  const referenceModelsResponse = await http.get<RefmodelResponse[]>(referenceModelsUrl);
  const referenceModels = referenceModelsResponse.data;
  // All reference models are now treated as regular refmodel entities (no drill patterns)
  return referenceModels.map(r => mapper.mapRefmodelToEntity(r));
};

/**
 * Fetch KML and KMZ files
 * @param {string} project_uuid
 */
const getDataSources:(project_uuid: string) => Promise<RefmodelResponse> =
  async (project_uuid) => {
    const dataSourcesUrl = `/api/one/v1/projects/${project_uuid}/data/?skip_pagination=true&format=json&extension__in=.KMZ&extension__in=.KML&refmod_meta_data=1`;
    const dataSourceResponse = await http.get(dataSourcesUrl);
    const dataSources = dataSourceResponse.data;
    const mappedDataSources = dataSources.map(mapper.mapDataSourceToEntity);
    return mappedDataSources;
  };

/**
 * Fetches the GLTF, that will be passed to Cesium to display reference model on the 3D map
 * @param {string} uuid
 * @returns GLTF model
 */
const getReferenceModelGltf: (uuid: string) => Promise<any> =
async (uuid) => {
  const modelConvertrUrl = `/api/one/v1/mapdata/${uuid}/?3DModel=1`;
  const model3DResponse = await http.get(modelConvertrUrl);
  if (model3DResponse.data === undefined) return model3DResponse; // We want to keep the json object containing the error
  if (model3DResponse.data.data === undefined) return model3DResponse.data; // Pretty usual case (cached model)
  return model3DResponse.data.data; // This is in case the model has not been cached
};

const refmodelApi = {
  getReferenceModels,
  getDataSources,
  getReferenceModelGltf
};

export default refmodelApi;